<template>
  <vee-field
    v-slot="{ componentField, errors }"
    v-model="claim[modelBindingProperty]"
    rules="required"
    :name="validationNameOrDefault"
  >
    <v-select
      v-bind="componentField"
      :disabled="disabled || !claim.date"
      :items="availableClaimTypes(claim)"
      :error-messages="errors"
      :placeholder="placeholderTextOrDefault"
      :label="label"
      item-value="id"
      name="expenseType"
      variant="outlined"
      density="compact"
      @update:model-value="resetClaimPayingOrgs"
    >
      <template #append>
        <v-icon tag="span">
          mdi-menu-down
        </v-icon>
      </template>

      <template #item="data">
        {{ data.item.nameWithOrgs }}
      </template>

      <template #selection="data">
        {{ data.item.name }}
      </template>
    </v-select>
  </vee-field>
</template>

<script>
import { filterAvailableClaimTypes } from "@/utils/claim";
import { Field as VeeField } from "vee-validate";

export default {
  name: "ReceiptClaimTypePicker",
  components: {
    VeeField
  },
  props: {
    claim: {
      type: Object,
      default: () => ({})
    },
    configurationTypeProperty: {
      type: String,
      required: true
    },
    filterEnabledTypesFunc: {
      type: Function,
      required: true
    },
    resourcesProperty: {
      type: String,
      required: true
    },
    modelBindingProperty: {
      type: String,
      required: true
    },
    validationName: {
      type: String
    },
    placeholderText: {
      type: String
    },
    label: {
      type: String
    },
    disabled: Boolean
  },
  computed: {
    placeholderTextOrDefault() {
      if (this.placeholderText) {
        return this.placeholderText;
      }

      return this.$t('claimPickersStrings.placeholders.claimType');
    },
    validationNameOrDefault(){
      if (this.validationName) {
        return this.validationName;
      }

      return this.$t('claimPickersStrings.tableHeaders.claimType');
    }
  },
  methods: {
    resetClaimPayingOrgs() {
      delete this.claim["payingOrgs"];
      this.claim.usesSalaryFraction = false;

      this.$emit("claim-type-change");
    },
    availableClaimTypes(claim) {
      return filterAvailableClaimTypes(
        claim,
        this.configurationTypeProperty,
        this.filterEnabledTypesFunc,
        this.resourcesProperty
      );
    }
  }
};
</script>
